module.exports = __webpack_public_path__ + "img/nature1.1933b20a.jpg";